import React, { InputHTMLAttributes, forwardRef } from 'react';

import { Typography } from 'antd';

import { GrayColors } from '@revenuemarket/cds/colors';
import { typographyStyle } from '@revenuemarket/cds/style/typography';

import { CheckboxWrapper, HiddenCheckbox, StyledCheckbox, LabelWrapper } from './style';
import CheckLine from '../Icon/CheckLine';
import Minus from '../Icon/Minus';

type CheckboxSize = 'medium' | 'large';
export interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
  labelStyle?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
  checkboxSize?: CheckboxSize;
  indeterminate?: boolean;
  showLabel?: boolean;
}

const sizeMap = {
  medium: { box: 14, icon: 20 },
  large: { box: 18, icon: 24 },
};

export const CheckboxV2 = forwardRef<HTMLInputElement, Props>(
  (
    {
      label,
      labelStyle,
      wrapperStyle,
      disabled,
      checked,
      checkboxSize = 'large',
      indeterminate = false,
      showLabel = true,
      ...props
    },
    ref,
  ) => {
    const boxSize = sizeMap[checkboxSize].box;
    const iconSize = sizeMap[checkboxSize].icon;
    return (
      <LabelWrapper disabled={disabled}>
        <CheckboxWrapper style={wrapperStyle}>
          <HiddenCheckbox
            ref={ref}
            type="checkbox"
            checked={checked}
            disabled={disabled}
            aria-checked={indeterminate ? 'mixed' : checked}
            {...props}
          />
          <StyledCheckbox checked={!!checked} disabled={!!disabled} boxSize={boxSize}>
            {indeterminate ? (
              <Minus
                width={iconSize}
                height={iconSize}
                fill={disabled ? GrayColors.grayOpacity22 : '#fff'}
              />
            ) : (
              checked && (
                <CheckLine
                  width={iconSize}
                  height={iconSize}
                  fill={disabled ? GrayColors.grayOpacity22 : '#fff'}
                />
              )
            )}
          </StyledCheckbox>
        </CheckboxWrapper>
        {showLabel && label && (
          <span>
            {typeof label === 'string' ? (
              <Typography.Text
                style={{
                  ...(checkboxSize === 'medium'
                    ? typographyStyle['14_400']
                    : typographyStyle['16_400']),
                  color: disabled ? GrayColors.gray400 : GrayColors.gray800,
                  ...labelStyle,
                }}
              >
                {label}
              </Typography.Text>
            ) : (
              <div style={labelStyle}>{label}</div>
            )}
          </span>
        )}
      </LabelWrapper>
    );
  },
);

CheckboxV2.displayName = 'CheckboxV2';
